import { Disclosure as Disc } from "@headlessui/react";
import React from "react";
import IconMinus from "./icons/minus";
import IconPlus from "./icons/plus";

export interface DisclosureNavProps {
  title: string;
  children: React.ReactNode;
}

const DisclosureNav: React.FC<DisclosureNavProps> = ({ title, children }) => {
  return (
    <Disc>
      {({ open }) => (
        <>
          <Disc.Button className="flex flex-row gap-2 items-center p-2 w-full cursor-pointer">
            <p className="w-full text-sm text-left">{title}</p>
            {open ? (
              <IconMinus className="w-5 h-5 shrink-0" />
            ) : (
              <IconPlus className="w-5 h-5 shrink-0" />
            )}
          </Disc.Button>
          <Disc.Panel className="pl-4 text-gray-500">
            <ul className="flex flex-col gap-2 pt-1 pb-2 w-full max-w-none prose prose-slate prose-headings:text-slate-700">
              {children}
            </ul>
          </Disc.Panel>
        </>
      )}
    </Disc>
  );
};

export default DisclosureNav;
